import React from 'react';

import { Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AvatarSize } from '../../../../shared/constants';
import { useStyles } from './UserListItemSkeleton.styles';

export default function UserListItemSkeleton() {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <div className={classes.userWrapper}>
      <Skeleton
        variant="circular"
        width={AvatarSize.m}
        height={AvatarSize.m}
        animation="wave"
      />
      <div className={classes.userDetails}>
        <div className={classes.infoWrapper}>
          <Skeleton variant="text" width="72%" height={28} animation="wave" />
        </div>
        <div className={classes.controlWrapper}>
          <Skeleton
            variant="rounded"
            width={100}
            height={36}
            animation="wave"
          />
        </div>
      </div>
    </div>
  );
}
